import View from "./View";
import registerView from "./registerView";
import logoRASHColor from 'url:../../img/logo/rash-log-ngjyra.png'

class ServiceView extends View {
    _parentElement = document.querySelector('.main');

    _generateMarkup() {
        this._parentElement.classList.add('main--transparent');

        window.scrollTo(0, 0);

        const markup = `
            <section class="section--application">
                <div class="service">
                    <h3 class="service__welcome">Mirë se vini në</h3>
                    <h2 class="service__title">${this._data.name}</h2>
                    <p class="service__text">${this._data.description}</p>
                    <div class="service__buttons">
                        ${this._generateMarkupServiceBtn()}
                    </div>
                </div>
                <div class="register">
                    ${registerView.render(this._data, false)}
                </div>
            </section>
        `;

        return markup;
    }

    _generateMarkupServiceBtn() {
         if (this._data.urlLogin && this._data.urlWebsite) {
            return `
            <a class="btn-img btn-img--round u-m-right-medium" href="${this._data.urlWebsite}" target="_blank">
                <img class="btn-img--round__img" src="${this._data.logo}" alt="${this._data.name} Logo">
            </a>
            <a class="btn-img btn-img--round u-m-right-medium" href="${this._data.urlLogin}" target="_blank">
                <img class="btn-img--round__img" src="${logoRASHColor}" alt="${this._data.name} Logo">
            </a>
        `
        } else if (this._data.urlLogin) {
            return `
                <a class="btn-img btn-img--round u-m-right-medium" href="${this._data.urlLogin}" target="_blank">
                    <img class="btn-img--round__img" src="${logoRASHColor}" alt="${this._data.name} Logo">
                </a>
            `
        } else if (this._data.urlWebsite) {
             return `
                <a class="btn-img btn-img--round u-m-right-medium" href="${this._data.urlWebsite}" target="_blank">
                    <img class="btn-img--round__img" src="${this._data.logo}" alt="${this._data.name} Logo">
                </a>
            `
         }

         return ``;
    }
}

export default new ServiceView();
